export default "__VITE_ASSET__nrN9rpA8__"